import {
    SHOW_CONFIRM,
    HIDE_CONFIRM,
} from '../types';

export const confirm = ({ title, message, onConfirm }) => {
    return {
        type: SHOW_CONFIRM,
        payload: { title, message, onConfirm },
    };
};

export const confirmDelete = (deletedName, onConfirm) => {
    return {
        type: SHOW_CONFIRM,
        payload: { deletedName, onConfirm },
    };
};

export const hideConfirm = () => {
    return {
        type: HIDE_CONFIRM,
    };
};
